export const state = {
  initialLoadCompleted: 0,
  auth: null,
  axiosError: null,
  submitting: false,
  online: true,
  axiosQueue: [],
  chunkState: {
    total: 0,
    processed: 0
  },
  axiosTiming: {},
  chatOpen: false,
  chatType: 'chat-float',
  chatActive: {
    id: null
  },
  allBookingsState: {
    dateFrom: null,
    user: null
  },
  bookingCalendarViewState: {
    dateFrom: null,
    dateTo: null,
    user: null
  },
  bookings: {},
  bookingsState: {
    tableRows: 20,
    page: 1,
    filters: {},
    sort: {
      col: 'due_at',
      dir: 'asc'
    }
  },
  customer: {},
  clientGlobal: {},
  clientContacts: {},
  customers: {},
  customersStore: [],
  customersState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    },
    search: {
      active: false,
      phrase: ''
    }
  },
  vehicle: {},
  vehicles: {},
  vehiclesStore: [],
  vehiclesState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    },
    search: {
      active: false,
      phrase: ''
    }
  },
  vehicleEvents: {},
  vehicleEventsState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'created_at',
      dir: 'desc'
    }
  },
  tracking: {},
  trackingState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'created_at',
      dir: 'desc'
    }
  },
  tasks: {},
  tasksStore: [],
  tasksState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    },
    search: {
      active: false,
      phrase: ''
    }
  },
  taskGroups: {},
  taskGroupsStore: [],
  taskGroupsState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    },
    search: {
      active: false,
      phrase: ''
    }
  },
  allContacts: {},
  contacts: {},
  contactsState: {
    tableRows: 5,
    page: 1,
    sort: {
      col: 'first_name',
      dir: 'asc'
    }
  },
  properties: {},
  propertiesStore: [],
  propertiesState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'label',
      dir: 'asc'
    }
  },
  schedules: {},
  schedulesStore: [],
  schedulesState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'due_at',
      dir: 'asc'
    }
  },
  documents: {},
  documentsState: {
    tableRows: 5,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    }
  },
  myScheduleToday: {},
  myScheduleTodayState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    }
  },
  listItems: {},
  listItemsState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'title',
      dir: 'asc'
    }
  },
  project: {},
  projects: {},
  projectsStore: [],
  projectsState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'title',
      dir: 'asc'
    }
  },
  projectWorkers: {},
  projectWorkersState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    }
  },
  projectTimers: {},
  projectTimersState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'created_at',
      dir: 'desc'
    }
  },
  notes: {},
  discussions: {
    discusssion: {},
    localDiscussions: {}
  },
  discussionsState: {
    tableRows: 20,
    page: 1,
    sort: {
      col: 'updated_at',
      dir: 'asc'
    }
  },
  comments: {},
  users: {},
  usersStore: [],
  usersState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    },
    icon: ['fal', 'user-friends']
  },
  roles: {},
  rolesState: {
    tableRows: 10,
    page: 1,
    sort: {
      col: 'name',
      dir: 'asc'
    },
    icon: ['fal', 'books']
  }
}
